
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div className="max-w-[1200px] mx-auto px-4 md:px-6 mt-8 md:mt-16 mb-8 md:mb-16">
      <div 
        ref={ref}
        className={`transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <Card className="w-full border-2 border-[#0F5E48] bg-[#0F5E48] rounded-xl md:rounded-2xl">
          <div className="text-center space-y-4 md:space-y-6 p-6 md:p-8">
            <h2 className="text-4xl md:text-6xl font-charter font-medium text-white leading-tight">
              Still have<br />questions?
            </h2>
            <Button 
              className="w-full md:w-auto bg-[#FAF9F8] hover:bg-[#104B60] text-black hover:text-white px-4 md:px-6 py-3 md:py-4 text-base md:text-lg h-auto rounded-full transition-colors"
              onClick={() => window.location.href = 'https://calendly.com/plannifi-demo/30min?back=1'}
            >
              Book a Free Demo
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CTASection;
